import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import {IsLoggedGuard} from 'src/app/guard/isLogged.guard';

const routes: Routes = [
  {
    /** Ingresso della demo pubblica. La sessione demo viene avviata dal
     *  bootstrap leggendo l'URL (DemoService.initFromUrl), qui resta solo il
     *  redirect sulla mappa. */
    path: 'demo',
    redirectTo: 'tabs',
    pathMatch: 'full'
  },
  {
    path: '',
    loadChildren: () => import('src/app/pages/mobile/common/tabs/tabs.module').then(m => m.TabsPageModule)
  },
  {
    path: 'login',
    loadChildren: () => import('src/app/pages/mobile/common/login/login.module').then(m => m.LoginPageModule)
  },
  {
    path: 'map',
    loadChildren: () => import('src/app/pages/mobile/common/map/map.module').then(m => m.MapPageModule)
  },
  {
    path: 'map-lists',
    loadChildren: () => import('src/app/pages/mobile/common/map-lists/map-lists.module').then(m => m.MapListsPageModule)
  },
  {
    path: 'history',
    loadChildren: () => import('src/app/pages/mobile/common/history/history.module').then(m => m.HistoryPageModule)
  },
  {
    path: 'history-cars',
    loadChildren: () => import('src/app/pages/mobile/common/history-cars/history-cars.module').then(m => m.HistoryCarsPageModule)
  },
  {
    path: 'history-map',
    loadChildren: () => import('src/app/pages/mobile/common/history-map/history-map.module').then(m => m.HistoryMapPageModule)
  }, {
    path: 'history-map-stop',
    loadChildren: () => import('src/app/pages/mobile/common/history-map-stop/history-map-stop.module').then(m => m.HistoryMapStopPageModule)
  },
  {
    path: 'alarms',
    loadChildren: () => import('src/app/pages/mobile/common/alarms/alarms.module').then(m => m.AlarmsPageModule)
  },
  {
    path: 'alarm-speed',
    loadChildren: () => import('src/app/pages/mobile/common/alarm-speed/alarm-speed.module').then(m => m.AlarmSpeedPageModule)
  },
  {
    path: 'alarm-speed-edit',
    loadChildren: () => import('src/app/pages/mobile/common/alarm-speed-edit/alarm-speed-edit.module').then(m => m.AlarmSpeedEditPageModule)
  },
  {
    path: 'alert',
    loadChildren: () => import('src/app/pages/mobile/common/alert/alert.module').then(m => m.AlertPageModule)
  },
  {
    path: 'alarm-poi',
    loadChildren: () => import('src/app/pages/mobile/common/alarm-poi/alarm-poi.module').then(m => m.AlarmPoiPageModule)
  },
  {
    path: 'alarm-poi-add',
    loadChildren: () => import('src/app/pages/mobile/common/alarm-poi-add/alarm-poi-add.module').then(m => m.AlarmPoiAddPageModule)
  },
  {
    path: 'menu',
    loadChildren: () => import('src/app/pages/mobile/common/menu/menu.module').then(m => m.MenuPageModule)
  },
  // { // ? see 'tickets-whatsapp'
  //   path: 'support',
  //   loadChildren: () => import('./support/support.module').then( m => m.SupportPageModule)
  // },
  {
    path: 'ticket',
    loadChildren: () => import('src/app/pages/mobile/common/ticket/ticket.module').then(m => m.TicketPageModule)
  },
  {
    path: 'tickets',
    loadChildren: () => import('src/app/pages/mobile/common/tickets/tickets.module').then(m => m.TicketsPageModule)
  },
  {
    path: 'ticket-send',
    loadChildren: () => import('src/app/pages/mobile/common/ticket-send/ticket-send.module').then(m => m.TicketSendPageModule)
  },
  {
    path: 'ticket-add',
    loadChildren: () => import('src/app/pages/mobile/common/ticket-add/ticket-add.module').then(m => m.TicketAddPageModule)
  },
  {
    path: 'notifications',
    loadChildren: () => import('src/app/pages/mobile/common/notifications/notifications.module').then(m => m.NotificationsPageModule)
  },
  {
    path: 'notifications-filter',
    loadChildren: () => import('src/app/pages/mobile/common/notifications-filter/notifications-filter.module').then(m => m.NotificationsFilterPageModule)
  },
  {
    path: 'notification',
    loadChildren: () => import('src/app/pages/mobile/common/notification/notification.module').then(m => m.NotificationPageModule)
  },
  {
    path: 'user-add',
    loadChildren: () => import('src/app/pages/mobile/common/user-add/user-add.module').then(m => m.UserAddPageModule)
  },
  {
    path: 'alarm-movement',
    loadChildren: () => import('src/app/pages/mobile/common/alarm-movement/alarm-movement.module').then(m => m.AlarmMovementPageModule)
  },
  {
    path: 'alarm-movement-edit',
    loadChildren: () => import('src/app/pages/mobile/common/alarm-movement-edit/alarm-movement-edit.module').then(m => m.AlarmMovementEditPageModule)
  },
  {
    path: 'alarm-unplug',
    loadChildren: () => import('src/app/pages/mobile/common/alarm-unplug/alarm-unplug.module').then(m => m.AlarmUnplugPageModule)
  },
  {
    path: 'alarm-unplug-edit',
    loadChildren: () => import('src/app/pages/mobile/common/alarm-unplug-edit/alarm-unplug-edit.module').then(m => m.AlarmUnplugEditPageModule)
  },
  {
    path: 'alarm-parking',
    loadChildren: () => import('src/app/pages/mobile/common/alarm-parking/alarm-parking.module').then(m => m.AlarmParkingPageModule)
  },
  {
    path: 'alarm-parking-edit',
    loadChildren: () => import('src/app/pages/mobile/common/alarm-parking-edit/alarm-parking-edit.module').then(m => m.AlarmParkingEditPageModule)
  },
  {
    path: 'alarm-offline',
    loadChildren: () => import('src/app/pages/mobile/common/alarm-offline/alarm-offline.module').then(m => m.AlarmOfflinePageModule)
  },
  {
    path: 'alarm-offline-edit',
    loadChildren: () => import('src/app/pages/mobile/common/alarm-offline-edit/alarm-offline-edit.module').then(m => m.AlarmOfflineEditPageModule)
  },
  {
    path: 'alarm-input-edit',
    loadChildren: () => import('src/app/pages/mobile/common/alarm-input-edit/alarm-input-edit.module').then(m => m.AlarmInputEditPageModule)
  },
  {
    path: 'alarm-input',
    loadChildren: () => import('src/app/pages/mobile/common/alarm-input/alarm-input.module').then(m => m.AlarmInputPageModule)
  },
  {
    path: 'user-data',
    loadChildren: () => import('src/app/pages/mobile/common/user-data/user-data.module').then(m => m.UserDataPageModule)
  },
  {
    path: 'marker-detail',
    loadChildren: () => import('src/app/pages/mobile/common/marker-detail/marker-detail.module').then(m => m.MarkerDetailPageModule)
  },
  {
    path: 'report',
    loadChildren: () => import('src/app/pages/mobile/common/report/report.module').then(m => m.ReportPageModule)
  },
  {
    path: 'li-actions-test',
    loadChildren: () => import('src/app/pages/mobile/common/li-actions-test/li-actions-test.module').then(m => m.LiActionsTestPageModule)
  },
  {
    path: 'not-permitted',
    loadChildren: () => import('src/app/pages/mobile/common/not-permitted/not-permitted.module').then(m => m.NotPermittedPageModule)
  },
  {
    path: 'report-launch',
    loadChildren: () => import('src/app/pages/mobile/common/report-launch/report-launch.module').then(m => m.ReportLaunchPageModule)
  },
  {
    path: 'report-list',
    loadChildren: () => import('src/app/pages/mobile/common/report-list/report-list.module').then(m => m.ReportListPageModule)
  },
  {
    path: 'account-settings',
    loadChildren: () => import('src/app/pages/mobile/common/account-settings/account-settings.module').then(m => m.AccountSettingsPageModule)
  },
  {
    path: 'cars',
    loadChildren: () => import('src/app/pages/mobile/common/cars/cars.module').then(m => m.CarsPageModule)
  },
  {
    path: 'car-detail',
    loadChildren: () => import('src/app/pages/mobile/common/car-detail/car-detail.module').then(m => m.CarDetailPageModule)
  },
  {
    path: 'subscription',
    loadChildren: () => import('src/app/pages/mobile/common/subscription/subscription.module').then(m => m.SubscriptionPageModule)
  },
  {
    path: 'car-fields',
    loadChildren: () => import('src/app/pages/mobile/common/car-fields/car-fields.module').then(m => m.CarFieldsPageModule)
  },
  {
    path: 'poi-add',
    loadChildren: () => import('src/app/pages/mobile/common/poi-add/poi-add.module').then(m => m.PoiAddPageModule)
  },
  {
    path: 'payment-problems',
    loadChildren: () => import('src/app/pages/mobile/common/payment-problems/payment-problems.module').then(m => m.PaymentProblemsPageModule)
  },
  { // ? see also: tab-routing.module.ts
    // path: 'tickets-whatsapp',
    path: 'support',
    loadChildren: () => import('src/app/pages/mobile/common/tickets-whatsapp/tickets-whatsapp.module').then(m => m.TicketsWhatsappPageModule)
  },
  {
    path: 'phone-add',
    loadChildren: () => import('src/app/pages/mobile/common/phone-add/phone-add.module').then(m => m.PhoneAddPageModule)
  },
  {
    path: 'referral',
    loadChildren: () => import('src/app/pages/mobile/common/referral/referral.module').then(m => m.ReferralPageModule)
  },
  {
    path: 'edit-referral',
    loadChildren: () => import('src/app/pages/mobile/common/edit-referral/edit-referral.module').then(m => m.EditReferralPageModule)
  },
  {
    path: 'payment',
    loadChildren: () => import('src/app/pages/mobile/common/payment/payment.module').then(m => m.PaymentPageModule)
  },
  {
    path:'payment-methods',
    loadChildren: () => import('src/app/pages/mobile/common/payment-methods/payment-methods.module').then( m => m.PaymentMethodsPageModule),
  },
  {
    path:'pay-invoice',
    loadChildren: () => import('src/app/pages/mobile/common/pay-invoice/pay-invoice.module').then( m => m.PayInvoicePageModule)
  },
  {
    path:'detail-invoice',
    loadChildren: () => import('src/app/pages/mobile/common/detail-invoice/detail-invoice.module').then( m => m.DetailInvoicePageModule),
  },
  {
    path: 'stripe-payment',
    loadChildren: () => import('src/app/pages/mobile/common/stripe-payment-methods/stripe-payment-methods.module').then( m => m.StripePaymentMethodsPageModule)
  },{
    path: 'recharge-balance',
    loadChildren: () => import('src/app/pages/mobile/common/recharge-balance/recharge-balance.module').then( m => m.RechargeBalancePageModule)
  },
  {
    path: 'finalize-order',
    loadChildren: () => import('src/app/pages/mobile/common/finalize-order/finalize-order.module').then(m => m.FinalizeOrderPageModule)
  },
  {
    path: 'order-history',
    loadChildren: () => import('src/app/pages/mobile/common/order-history/order-history.module').then(m => m.OrderHistoryPageModule)
  },
  {
    path: 'free-trial',
    loadChildren: () => import('src/app/pages/mobile/common/free-trial/free-trial.module').then(m => m.FreeTrialPageModule)
  },
  {
    path: 'share-posizione',
    loadChildren: () => import('src/app/pages/common/share-posizione/share-posizione.module').then( m => m.SharePosizionePageModule)
  },
  {
    path: 'consegne-pubblico/:token',
    loadChildren: () => import('src/app/pages/common/consegne-pubblico/consegne-pubblico.module').then( m => m.ConsegnePubblicoPageModule)
  },
  {
    path: 'share-links/public',
    loadChildren: () => import('src/app/pages/common/share-links-public/share-links-public.module').then( m => m.ShareLinksPublicPageModule)
  },
  {
    path: 's/:token',
    loadChildren: () => import('src/app/pages/common/share-links-public/share-links-public.module').then( m => m.ShareLinksPublicPageModule)
  },
  {
    path: 'login-modal',
    loadChildren: () => import('src/app/pages/mobile/common/login-modal/login-modal.module').then(m => m.LoginModalPageModule)
  },
  {
    path: 'shop',
    redirectTo: 'tabs/menu/shop',
    pathMatch: 'full'
  },
  {
    path: 'activation',
    redirectTo: 'tabs/menu/activation',
    pathMatch: 'full'
  },
  {
    path: 'condivisione_posizione',
    redirectTo: 'tabs/menu/condivisione-posizione',
    pathMatch: 'full'
  },
  {
    path: 'billing',
    redirectTo: 'tabs/menu/payment',
    pathMatch: 'full'
  },
  {
    path: 'orders',
    redirectTo: 'tabs/menu/order-history',
    pathMatch: 'full'
  },
  {
    path: 'users',
    redirectTo: 'tabs/menu/users',
    pathMatch: 'full'
  },
  {
    path: 'alarm-cars',
    redirectTo: 'tabs/alarm-cars',
    pathMatch: 'full'
  },
  {
    path: 'new-ticket',
    loadChildren: () => import('src/app/pages/mobile/common/new-ticket/new-ticket.module').then( m => m.NewTicketPageModule)
  },
  {
    path: 'ticket-detail',
    loadChildren: () => import('src/app/pages/mobile/common/ticket-detail/ticket-detail.module').then( m => m.TicketDetailPageModule)
  },
  {
    path: 'activation',
    loadChildren: () => import('src/app/pages/mobile/common/activation/activation-routing.module').then( m => m.ActivationPageRoutingModule)
  },
  {
    path: 'change-password',
    canActivate: [IsLoggedGuard],
    loadChildren: () => import('src/app/pages/mobile/common/change-password/change-password.module').then( m => m.ChangePasswordPageModule)
  },
  {
    path: 'report-batch-list',
    loadChildren: () => import('src/app/pages/mobile/common/report-batch-list/report-batch-list.module').then(m => m.ReportBatchListPageModule)
  },
  {
    path: 'fleet-lists',
    loadChildren: () => import('src/app/pages/mobile/common/fleet-lists/fleet-lists.module').then(m => m.FleetListsPageModule)
  },
  {
    path: 'report-launch-ingressi',
    loadChildren: () => import('src/app/pages/mobile/common/report-launch-ingressi/report-launch-ingressi.module').then( m => m.ReportLaunchIngressiPageModule)
  }

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
